import { AdminOfficer, DiocesanAdministrator, DiocesanAssociateAdministrator, JuniorGroupPlanAdmin, SeniorGroupPlanAdmin, SeniorOfficer } from '../../pages/arc/constants/constant-strings';
import { RoleObject } from '../models/authenticated-model';

export const useAdminStatus = (token: RoleObject) => {

	if (!token) {
		return false;
	}

	const dioAdmins = token?.institution_roster?.map(a => a.role_name);
	const employeeRoster = token?.employee_roster?.map(a => a.role_name);
	const mlps = token?.mlps?.map(a => a.role_name);

	// commenting for now until admin roles are finalized
	//const diocesanReports = token[Roles][DiocesanReports];

	return (dioAdmins && (dioAdmins?.includes(DiocesanAssociateAdministrator) || dioAdmins?.includes(DiocesanAdministrator)))
		|| (employeeRoster && (employeeRoster?.includes(SeniorOfficer) || employeeRoster?.includes(AdminOfficer)))
		|| (mlps && (mlps?.includes(SeniorGroupPlanAdmin) || mlps?.includes(JuniorGroupPlanAdmin)));

};